import Action from "../../classes/Action";
import { JsonCopy } from "../../classes/utilities/Misc";
import AssetsLibraryUtilities from "../../components/filebrowser/AssetsLibraryUtilities";
import { IVisageTemplate } from "../../interfaces/VisageUI";
import store, { StoreActions } from "../../state/store";

export default class DeleteUITemplateAction extends Action
{
	constructor(templateId: string)	
	{
		const templateData: IVisageTemplate = JsonCopy(store.getState().visageModule.uiTemplateData[templateId] ?? {} as IVisageTemplate);

		super(
			[templateId],
			[templateData],
			`Delete UI Template ${templateId}`,
			[templateData]
		);
	}

	do(templateId: string): void
	{
		store.dispatch(StoreActions.visage.deleteUITemplateData({ templateId: templateId }));
		AssetsLibraryUtilities.refresh();
	}

	undo(templateData: IVisageTemplate): void 
	{
		store.dispatch(StoreActions.visage.setUITemplateData({ templateId: templateData.id, data: JsonCopy(templateData) }));
		AssetsLibraryUtilities.refresh();
	}

	verify(templateData: IVisageTemplate): boolean 
	{
		return templateData.id !== "";
	}
}